/**
 * embroideryPatterns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const embroideryPatternsPack: ToilePack = {
    slug: 'embroidery-patterns',
    category: 'craft',
    name: 'Embroidery & craft patterns',
    tagline: tagline('patterns', 'motifs', 'techniques'),
    chips: chips('motifs', 'techniques'),
    ratio: SQUARE,
    readings: [
        {key: 'fox', label: 'Fox', subject: 'a sitting fox among ferns and mushrooms'},
        {key: 'wildflowers', label: 'Wildflowers', subject: 'a wildflower bouquet, poppies and cornflowers, ribbon-tied'},
        {key: 'ship', label: 'Sailing ship', subject: 'a three-masted sailing ship on rolling waves'},
    ],
    styles: [
        {key: 'hoop', label: 'Embroidery hoop', style: 'finished hand-embroidery in a wooden hoop', palette: 'cotton floss on linen', framing: 'flat, straight on'},
        {key: 'chart', label: 'Cross-stitch chart', style: 'cross-stitch pattern chart, pixel grid', palette: 'colored squares on white grid', framing: 'flat, straight on'},
        {key: 'seamless', label: 'Seamless tile', style: 'seamless repeating surface pattern', palette: 'flat, tileable colors', framing: 'flat, straight on'},
    ],
    directions: ['a mountain range instead', 'in a two-color palette', 'simpler, fewer stitches'],
}
